"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIgnoreSocialDataForRegistration = void 0;
const getIgnoreSocialDataForRegistration = (socialType, config) => {
  const falseSocials = config.getStrict('auth.ignoreSocialDataForRegistration.disabled');
  return !falseSocials.includes(socialType);
};
exports.getIgnoreSocialDataForRegistration = getIgnoreSocialDataForRegistration;